module.exports = __webpack_public_path__ + "assets/img/fangda_def@2x.e279bae4.jpg";